import React, { useEffect, useState } from 'react'
import { Col, Row, Progress, Card, Button, Modal, Input, message, Space, Spin, Flex, Typography } from 'antd'
import { format } from '../helpers/number'
import api from '../helpers/api'
import { toast } from 'react-toastify'
import { ApplicationState } from '../store'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router'
import useSWR from 'swr'
import { CopyOutlined } from '@ant-design/icons'
import { redeemDeposit } from '../services/deposit'
import { CloseCircleOutlined } from '@ant-design/icons';
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { prefixAllow, prefixAllowN } from '../helpers/prefixAllow'

interface IDailyMission {
    todayDeposit: number
    quests: {
        id: number
        targetAmount: number
        reward: number
        completed: boolean
        claimed: boolean
    }[]
}

const Mission = () => {
    const prefix: any = useSelector((state: ApplicationState) => state.prefix.info)
    const userState = useSelector((state: ApplicationState) => state.user)
    const prefixMission = [...prefixAllow, ...prefixAllowN, 'SHABU'] //eslint-disable-line
    const [isSubmitting, setSubmitting] = useState<boolean>(false)
    const [lineID, setLineID] = useState<string>("")

    const [dailyQuest, setDailyQuest] = useState<IDailyMission>({
        todayDeposit: 0,
        quests: [
            { id: 1, targetAmount: 500, reward: 25, completed: false, claimed: false },
            { id: 2, targetAmount: 1000, reward: 50, completed: false, claimed: false },
            { id: 3, targetAmount: 5000, reward: 250, completed: false, claimed: false },
            { id: 4, targetAmount: 10000, reward: 1000, completed: false, claimed: false }
        ]
    })
    const [couponModal, setCouponModal] = useState<{
        visible: boolean
        couponCode: string
        reward: number
    }>({
        visible: false,
        couponCode: '',
        reward: 0
    })

    const getDailyQuest = async () => {
        try {
            const res = await api.get<void, any>(`/member/deposit/today`)
            const depositAmount = res?.depositToday || 0

            // Update todayDeposit in dailyQuest state
            setDailyQuest(prev => ({
                ...prev,
                todayDeposit: depositAmount
            }))

            return depositAmount
        } catch ({ message }: any) {
            toast.error(message as string)
            return null
        }
    }

    const claimReward = async (questId: number) => {
        setSubmitting(true)
        // Find the quest to get reward amount
        const quest = dailyQuest.quests.find(q => q.id === questId)
        if (!quest) return

        let couponCode = ""

        // // Set coupon code based on target amount
        // switch (quest.targetAmount) {
        //     case 500:
        //         couponCode = "F7U72FLUXJZ3RQTC16"
        //         break
        //     case 1000:
        //         couponCode = "XJ8CIM6P8KXNKJUC14"
        //         break
        //     case 5000:
        //         couponCode = ""
        //         break
        //     case 10000:
        //         couponCode = ""
        //         break
        //     default:
        //         couponCode = "default"
        // }

        // try {

        //     await redeemDeposit({
        //         code: couponCode,
        //     })
        //     setCouponModal({
        //         visible: true,
        //         couponCode: couponCode,
        //         reward: quest.reward
        //     })

        // } catch ({ message }: any) {
        //     toast.error("คุณเคยรับรางวัลนี้แล้ว")
        //     setSubmitting(false)
        // } finally {
        //     setSubmitting(false)
        // }

        setCouponModal({
            visible: true,
            couponCode: "",
            reward: quest.reward
        })
        setSubmitting(false)

    }

    const copyCouponCode = () => {
        navigator.clipboard.writeText(couponModal.couponCode)
        message.success('คัดลอกโค้ดคูปองแล้ว!')
    }

    const closeCouponModal = () => {
        setCouponModal({
            visible: false,
            couponCode: '',
            reward: 0
        })
    }

    const { data: questData } = useSWR([`/member/daily-quest`], () => getDailyQuest(), { refreshInterval: 30000 });

    useEffect(() => {
        if (questData && questData.quests) {
            setDailyQuest(questData)
        }
    }, [questData])

    useEffect(() => {
        if (prefix?.socialMedia) {
            if (prefix?.socialMedia.line) {
                const re = "line://ti/p/"
                setLineID(prefix?.socialMedia.line.replace(re, ""))
            }
        }
    }, [prefix])

    const renderDailyQuest = () => {
        // Add safety check for quests array
        if (!dailyQuest.quests || !Array.isArray(dailyQuest.quests)) {
            return <div style={{ color: '#fff', textAlign: 'center', padding: 20 }}>กำลังโหลดข้อมูล...</div>
        }

        return (
            <>
                {dailyQuest.quests.map((quest) => {
                    const progress = Math.min((dailyQuest.todayDeposit / quest.targetAmount) * 100, 100)
                    const isCompleted = dailyQuest.todayDeposit >= quest.targetAmount

                    return (
                        <div key={quest.id} style={{ marginBottom: 16, padding: 16, backgroundColor: '#262626', borderRadius: 8 }}>
                            <Row justify="space-between" align="middle" style={{ marginBottom: 8 }}>
                                <Col>
                                    <div style={{ color: '#fff', fontSize: 24 }}>
                                        ฝากครบ {format(quest.targetAmount, 0)} บาท
                                    </div>
                                    <div style={{ color: '#52c41a', fontSize: 22 }}>
                                        รางวัล: {format(quest.reward, 0)} บาท
                                    </div>
                                </Col>
                                <Col>
                                    <Button
                                        type="default"
                                        disabled={!isCompleted || quest.claimed}
                                        onClick={() => claimReward(quest.id)}
                                        loading={isSubmitting}
                                        className={`ant-btn ant-btn-default ant-btn-mission ${quest.claimed ? 'claimed' : isCompleted ? 'completed' : 'claimed'}`}
                                    // style={{
                                    //     backgroundColor: quest.claimed ? '#666' : isCompleted ? '#52c41a' : '#666',
                                    //     borderColor: quest.claimed ? '#666' : isCompleted ? '#52c41a' : '#666'
                                    // }}
                                    >
                                        {quest.claimed ? 'รับแล้ว' : isCompleted ? 'รับรางวัล' : 'ยังไม่ครบ'}
                                    </Button>
                                </Col>
                            </Row>

                            <Progress
                                percent={progress}
                                strokeColor={{
                                    '0%': '#108ee9',
                                    '100%': '#52c41a',
                                }}
                                trailColor="#444"
                                showInfo={true}
                                format={(percent) => `${Math.round(percent || 0)}%`}
                            />
                        </div>
                    )
                })}
            </>
        )
    }

    if (!prefixMission.includes(prefix?.prefix as string)) {
        return <Redirect to="wallet" />
    }

    return (
        <>
            {/* Today's Deposit Display - Beautiful Version */}
            <div className="mission__deposit-display">
                {/* Background decoration */}
                <div className="mission__deposit-display__decoration" />

                <div className="mission__deposit-display__content">
                    <div className="mission__deposit-display__header">
                        <div className="mission__deposit-display__header__icon">
                            {prefix.icon ? (
                                <img
                                    src={prefix.icon}
                                    className="logo-misson"
                                    alt="icon"
                                />
                            ) : (prefix.logo) && (
                                <img
                                    src={prefix.logo}
                                    className="logo-misson"
                                    alt="logo"
                                />
                            )}
                        </div>
                        <span className="mission__deposit-display__header__label">
                            ยอดฝากวันนี้
                        </span>
                    </div>

                    <div className="mission__deposit-display__amount">
                        {format(dailyQuest.todayDeposit, 0)} <span className="mission__deposit-display__amount__unit">บาท</span>
                    </div>
                </div>
            </div>

            {/* Daily Quest Section */}
            {renderDailyQuest()}

            {/* Coupon Modal */}
            {/* <Modal
                className="ant-popup ant-redeem-success-popup"
                open={couponModal.visible}
                title=""
                centered
                onCancel={closeCouponModal}
                footer={null}
            >
                <div className="redeem-success-container">
                    <img className="polar animated" src="/redeem-success/polar.webp" alt="polar" />
                    <img className="gift-bottom animated" src="/redeem-success/gift-bottom.webp" alt="gift-bottom" />
                    <img className="light-in-box animated" src="/redeem-success/light-in-box.webp" alt="light-in-box" />
                    <img className="flare-4 animated" src="/redeem-success/flare-4.webp" alt="flare-4" />
                    <img className="flare-3 animated" src="/redeem-success/flare-3.webp" alt="flare-3" />
                    <img className="flare-2 animated" src="/redeem-success/flare-2.webp" alt="flare-2" />
                    <div className="coin-container animated">
                        <img className="coin" src="/redeem-success/coin.webp" alt="coin" />
                        <div className={`coin-amount ${couponModal.reward >= 100 ? 'text-small' : ''}`}>{format(couponModal.reward, 0)}</div>
                    </div>
                    <img className="flare-1 animated" src="/redeem-success/flare-1.webp" alt="flare-1" />
                    <img className="gift-top animated" src="/redeem-success/gift-top.webp" alt="gift-top" />
                    <img className="congrat animated" src="/redeem-success/congrat.gif" alt="congrat" />
                    <div className="redeem-success-title">ยินดีด้วย!</div>
                    <div className={`redeem-success-result`}>คุณได้รับ {format(couponModal.reward, 0)} บาท</div>
                    <div className="reddem-success-close" onClick={() => { closeCouponModal(); }}>
                        <CloseCircleOutlined style={{ fontSize: 48 }} />
                    </div>
                </div>

            </Modal > */}
            {/* <Modal
                title="🎉 รับรางวัลสำเร็จ!"
                open={couponModal.visible}
                onCancel={closeCouponModal}
                footer={null}
                centered
            >
                <div>
                    <div style={{ marginBottom: 8, fontSize: 22 }}>
                        โค้ดเครดิต {format(couponModal.reward, 0)} บาท
                    </div>

                    <Space.Compact style={{ width: '100%' }}>
                        <Input value={couponModal.couponCode} style={{ paddingTop: 0, paddingBottom: 0 }} readOnly />
                        <Button type="primary" icon={<CopyOutlined />} onClick={copyCouponCode} />
                    </Space.Compact>
                </div>
            </Modal> */}
            <Modal
                title="🎉 รับรางวัล!"
                open={couponModal.visible}
                onCancel={closeCouponModal}
                footer={null}
                centered
            >
                <div>
                    <div style={{ marginBottom: 8, fontSize: 22 }}>
                        โค้ดเครดิต {format(couponModal.reward, 0)} บาท
                    </div>
                    <div style={{ marginBottom: 16, fontSize: 22 }}>
                        จับภาพหน้าจอและคลิกเข้าไลน์ แจ้งเบอร์โทรศัพท์ให้แอดมินทราบเพื่อรับโค้ดคูปอง
                    </div>

                    <Space.Compact style={{ width: '100%' }}>
                        {prefix?.socialMedia && prefix?.socialMedia.line &&
                            <Typography.Link href={prefix?.socialMedia.line} target="_blank" rel="noreferrer" style={{ width: '100%' }}>
                                <div className="contact-card">
                                    <div className="contact-icon">
                                        {/* <img src={`contacts/line.svg`} alt="" /> */}
                                        <LazyLoadImage
                                            alt={'line'}
                                            effect={'blur'}
                                            src={`contacts/line.svg`}
                                        />
                                    </div>
                                    <div className="contact-text">
                                        <Space direction="vertical">
                                            <Typography.Text strong>Line</Typography.Text>
                                            {lineID}
                                        </Space>
                                    </div>
                                </div>
                            </Typography.Link>
                        }
                    </Space.Compact>
                </div>
            </Modal>
        </>
    )
}

export default Mission